import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiArrowRight } = FiIcons;

const LowStockAlert = ({ products }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-red-50 border border-red-200 rounded-xl p-6"
    >
      <div className="flex items-center mb-4">
        <SafeIcon icon={FiAlertTriangle} className="h-6 w-6 text-red-600 mr-3" />
        <h3 className="text-lg font-semibold text-red-800">Low Stock Alert</h3>
      </div>
      
      <p className="text-red-700 mb-4">
        The following products are running low on stock:
      </p>
      
      <div className="space-y-2 mb-4">
        {products.slice(0, 5).map((product) => (
          <div 
            key={product.id}
            className="flex items-center justify-between bg-white rounded-lg p-3 border border-red-100"
          >
            <div>
              <p className="font-medium text-gray-900">{product.name}</p>
              <p className="text-sm text-gray-600">SKU: {product.localSku}</p>
            </div>
            <span className="text-red-600 font-bold">{product.quantity} left</span>
          </div>
        ))}
      </div>
      
      {products.length > 5 && (
        <p className="text-red-600 text-sm mb-4">
          And {products.length - 5} more products...
        </p>
      )}
      
      <button
        onClick={() => navigate('/products')}
        className="flex items-center text-red-700 hover:text-red-800 font-medium transition-colors duration-200"
      >
        View all products
        <SafeIcon icon={FiArrowRight} className="ml-2 h-4 w-4" />
      </button>
    </motion.div>
  );
};

export default LowStockAlert;